import { createContext } from "react";
import type { RecordType } from "src/gqty";

export type RecordScreenDestination = {
  recordType: RecordType;
  recordId: string;
  initialTab?: string;
  initialPath?: string[];
};

export const RecordScreenNavigationContext = createContext<{
  recordType: RecordType;
  recordId: string;
  navigate: (destination: RecordScreenDestination) => Promise<void>;
} | null>(null);
